module.exports = __webpack_public_path__ + "img/spouting_whale.02850c64.gif";